import {initBreadcrumb} from './breadcrumb.js';

initBreadcrumb();